import { css } from '@emotion/core'
import { useLocation } from '@reach/router'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { headerHeight } from '../constants/header'
import ExpertsSVG from '../icons/templates/experts.svg'
import PencilSVG from '../icons/templates/pencil.svg'
import StarSVG from '../icons/templates/star.svg'
import { TemplateLinksNavigationProps } from '../interfaces/templates'
import { Link } from './Link'
import SearchBar from './Search'

export const TemplateLinksNavigation: React.FC<TemplateLinksNavigationProps> = ({ categories, search, setSearch }) => {
  const location = useLocation()

  return (
    <div className="hide-on-small-medium" css={containerStyle}>
      <SearchBar
        isInSidebar
        search={search}
        setSearch={setSearch}
        placeholder="Search templates..."
        cssStyles={searchBarStyle}
      />
      <ul css={listStyle}>
        <li>
          <StarSVG css={starStyle(location.pathname === '/templates/')} />
          <Link
            href="/templates/"
            className={`body-1 opacity-on-hover ${location.pathname === '/templates/' ? 'blue-text' : 'black-text'}`}
          >
            Featured
          </Link>
        </li>
        {categories.map(({ node: { id, slug, name } }) => {
          return (
            <li key={`links-navigation-${slug}`}>
              {/* id === Experts */}
              {id === '8db6e1f9-c1fe-5f3d-b78c-35ab07d15f3d' && (
                <ExpertsSVG css={starStyle(location.pathname === '/templates/category/experts/')} />
              )}
              <Link
                href={`/templates/category/${slug}/`}
                className={`body-1 opacity-on-hover ${
                  location.pathname.includes(`category/${slug}`) ? 'blue-text' : 'black-text'
                }`}
              >
                {name}
              </Link>
            </li>
          )
        })}
        <li>
          <PencilSVG css={starStyle(location.pathname === '/templates/submit-own-template/')} />
          <Link
            href="/templates/submit-own-template/"
            className={`body-1 opacity-on-hover ${
              location.pathname === '/templates/submit-own-template/' ? 'blue-text' : 'black-text'
            }`}
          >
            Submit your own
          </Link>
        </li>
      </ul>
    </div>
  )
}

const starStyle = (isSelected: boolean) => css`
  margin-right: 0.5rem;
  ${isSelected && 'path {stroke: #318eff}'};
`

const listStyle = css`
  li {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0.25rem;
    }

    svg {
      transform: translateY(1px);
    }
  }
`

const containerStyle = css`
  position: sticky;
  top: calc(${headerHeight}px + 1.5rem);
`

const searchBarStyle = css`
  @media screen and (max-width: ${breakpoints.xlarge}px) {
    & > div > div {
      grid-template-columns: 20px 140px 20px !important;
    }
  }
`
